/* =========================================================
   WoodBuzz Bulk Order — Interactions & Form Submission
   ========================================================= */

/* ----- Utility --------------------------------------------- */
const $ = (s, el = document) => el.querySelector(s);
const $$ = (s, el = document) => [...el.querySelectorAll(s)];

/* ----- Run bindings once DOM content is ready ----- */
const initBulkOrder = () => {
  // 1. FAQ Accordions toggle click handler
  $$('.wbb-faq-item .wbb-faq-q').forEach(btn => {
    btn.addEventListener('click', () => btn.parentElement.classList.toggle('open'));
  });

  // 2. Reveal on Scroll (Intersection Observer)
  const revealEls = $$('.reveal');
  if (revealEls.length > 0) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: "0px 0px -60px 0px" });
    revealEls.forEach(el => io.observe(el));
  }

  // 3. Counter Animations
  const counters = $$('[data-count]');
  if (counters.length > 0) {
    const easeOut = (t) => 1 - Math.pow(1 - t, 3);
    const animateCounter = (el) => {
      const target = parseInt(el.dataset.count, 10);
      const suffix = el.dataset.suffix || '';
      const dur = 1600;
      const start = performance.now();
      const step = (now) => {
        const p = Math.min(1, (now - start) / dur);
        const val = Math.floor(easeOut(p) * target);
        el.textContent = val.toLocaleString('en-IN') + suffix;
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = target.toLocaleString('en-IN') + suffix;
      };
      requestAnimationFrame(step);
    };
    const counterObs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          animateCounter(e.target);
          counterObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.5 });
    counters.forEach(el => counterObs.observe(el));
  }

  // 4. Modal Popups Handlers
  const modal = $('#leadModal');
  const openModal = (tier) => {
    if (!modal) return;
    modal.classList.add('open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (tier) {
      const msg = $('#message');
      if (msg && !msg.value) msg.value = `Interested in the ${tier} engagement model.`;
    }
    setTimeout(() => {
      const f = $('#companyName');
      if (f) f.focus();
    }, 300);
  };

  window.closeModal = () => {
    if (!modal) return;
    modal.classList.remove('open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  // Bind trigger buttons
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-open-form]');
    if (trigger) {
      e.preventDefault();
      openModal(trigger.dataset.tier);
    }
  });

  const closeBtn = $('#modalClose');
  if (closeBtn) closeBtn.addEventListener('click', window.closeModal);
  if (modal) {
    modal.addEventListener('click', (e) => { if (e.target === modal) window.closeModal(); });
  }
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') window.closeModal(); });

  // 5. AJAX B2B enquiry submission
  const form = $('#leadForm');
  const submitBtn = $('#leadSubmit');
  const statusBox = $('#formStatus');

  if (form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!statusBox || !submitBtn) return;
      statusBox.className = 'form-status';
      statusBox.textContent = '';
      statusBox.style.display = 'none';

      const data = {
        companyName: $('#companyName').value.trim(),
        contactPerson: $('#contactPerson').value.trim(),
        mobile: $('#mobile').value.trim(),
        email: $('#email').value.trim(),
        projectType: $('#projectType').value.trim(),
        city: $('#city').value.trim(),
        quantity: $('#quantity').value.trim(),
        budget: $('#budget').value.trim(),
        message: $('#message').value.trim(),
        _subject: 'New Bulk Order B2B Inquiry'
      };

      if (!data.companyName || !data.contactPerson || !data.mobile) {
        statusBox.className = 'form-status err';
        statusBox.textContent = 'Please fill company name, contact person and mobile number.';
        return;
      }

      submitBtn.disabled = true;
      const submitLbl = submitBtn.querySelector('.submit-label');
      const submitLdr = submitBtn.querySelector('.submit-loader');
      if (submitLbl) submitLbl.textContent = 'Sending…';
      if (submitLdr) submitLdr.style.display = 'inline-block';

      try {
        const res = await fetch('https://formsubmit.co/ajax/Abhishek.sahu@ixdesigns.in', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(data),
        });
        const json = await res.json();
        if (json.success === "true" || json.success === true || res.ok) {
          form.style.display = 'none';
          const successDiv = document.createElement('div');
          successDiv.className = 'success-message';
          successDiv.innerHTML = `
            <div style="text-align:center;padding:40px 20px;">
              <div style="width: 60px; height: 60px; border-radius: 50%; background: rgba(240,169,63,0.12); color: var(--amber-2); display:inline-flex; align-items:center; justify-content:center; margin-bottom: 16px; font-size: 24px; font-weight:bold;">✓</div>
              <h3 style="font-family:var(--serif);font-size:28px;color:var(--heading);margin-bottom:8px;font-weight:600;">Enquiry Sent!</h3>
              <p style="color:var(--text-muted);font-size:15px;margin-bottom:20px;line-height:1.6;">Your B2B enquiry has been received. Our sales manager will contact you within 24 hours.</p>
              <button class="btn btn-primary" onclick="closeModal()">Close</button>
            </div>
          `;
          form.parentElement.appendChild(successDiv);
        } else {
          throw new Error('Form submission failed.');
        }
      } catch (err) {
        submitBtn.disabled = false;
        if (submitLbl) submitLbl.textContent = 'Get Bulk Pricing';
        if (submitLdr) submitLdr.style.display = 'none';
        statusBox.className = 'form-status err';
        statusBox.textContent = err.message || 'Something went wrong. Please try again.';
      }
    });
  }

  // 6. Mobile Header Menu Drawer
  const mobileMenuBtn = $('#mobileMenuBtn');
  const mobileMenuClose = $('#mobileMenuClose');
  const mobileMenuDrawer = $('#mobileMenuDrawer');
  if (mobileMenuBtn && mobileMenuDrawer) {
    mobileMenuBtn.addEventListener('click', () => {
      mobileMenuDrawer.classList.remove('pointer-events-none');
      mobileMenuDrawer.classList.remove('opacity-0');
      mobileMenuDrawer.classList.add('opacity-100');
      const inner = mobileMenuDrawer.querySelector('.transform');
      if (inner) {
        inner.classList.remove('translate-x-full');
        inner.classList.add('translate-x-0');
      }
    });
  }
  const closeMobileMenu = () => {
    if (mobileMenuDrawer) {
      mobileMenuDrawer.classList.add('pointer-events-none');
      mobileMenuDrawer.classList.remove('opacity-100');
      mobileMenuDrawer.classList.add('opacity-0');
      const inner = mobileMenuDrawer.querySelector('.transform');
      if (inner) {
        inner.classList.remove('translate-x-0');
        inner.classList.add('translate-x-full');
      }
    }
  };
  if (mobileMenuClose) mobileMenuClose.addEventListener('click', closeMobileMenu);
  if (mobileMenuDrawer) {
    mobileMenuDrawer.addEventListener('click', (e) => {
      if (e.target === mobileMenuDrawer) closeMobileMenu();
    });
    mobileMenuDrawer.querySelectorAll('.mobile-nav-link').forEach(link => {
      link.addEventListener('click', closeMobileMenu);
    });
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBulkOrder);
} else {
  initBulkOrder();
}
